import {useEffect, useState} from 'react';
import { jsxActions as shipmentPageActions} from '../../actions/ShipmentPage/shipmentPageActions.js';
import { jsxActions as shipmentLotsGridActions} from '../../actions/ShipmentPage/shipmentLotsGridActions.js';
import { jsxActions as fetchEntitiesActions} from '../../actions/FetchEntities/fetchEntitiesActions.js';
import useRedux from 'infrastructure/js/hooks/useRedux';
import useLabels from 'infrastructure/js/hooks/useLabels';
import Overlay from 'infrastructure/js/components/Overlay/overlay';
import useNavBarUpdate from 'infrastructure/js/hooks/useNavBarUpdate';
import {navigationStates} from '../../enums/navigationStates';

import ShipmentPage from './shipmentPage';

const getState = (state) => {
  return {
    loading: state.shipmentPage.get('loading'),
    shipmentId: state.shipmentPage.get('shipmentId'),
  }
}

const allActions = {
  shipmentPageActions: shipmentPageActions,
  shipmentLotsGridActions: shipmentLotsGridActions,
  fetchEntitiesActions: fetchEntitiesActions,
};


function ShipmentPageWrapper (props) {

  const labels = useLabels('mat.shipment.cocSummary.');

  const { state, actions } = useRedux(allActions, getState);
  const { loading } = state;

  const [initialized, setInitialized] = useState(false);
  const [item, setItem] = useState(null);

  const shipmentId = props.match.params.shipmentId;

  const updateNavBar = useNavBarUpdate();

  useEffect(() => {
    if (shipmentId) {
      actions.shipmentPageActions.setShipmentId(+shipmentId);
      actions.shipmentPageActions.init(+shipmentId).then(data => {
        if (data) {
          setItem(data);
        }
        setInitialized(true);
      })
    }
    else {
      setInitialized(true);
    }

    return () => {
      setInitialized(false);
      actions.shipmentPageActions.unmount();
    }
  }, [props.match.params.shipmentId]);

  useEffect(() => {
    updateNavBar(navigationStates.SHIPMENT, item?.businessId ?? '' );
  }, [updateNavBar, item]);


  return  initialized ?

    <ShipmentPage initialData={item}
             actions={actions}
             loading={loading}
             {...props } /> :
    <Overlay.Loading />
}

export default ShipmentPageWrapper;
